<template>
  <span>
    <span v-if="showNewProjectForm">

        <div @click.stop="">
          <input  type="text" v-model="project_area_name" :placeholder="$t('categories.new')" class="form-control" v-on:change="changeListener" style="width:150px">
          <small v-on:click="showExistingProjectAreas" class="pointer float-right">or use existing {{ $t("categories.singular") }} </small>
        </div>

    </span>
    <span v-else>
      <select name="project_area_id" v-model="project_area_id" class="custom-select" v-on:change="changeListener">
        <option v-for="project_area in project_areas" :value="project_area.id">
          {{ project_area.name }}
        </option>
        <option value='new_project'> - New {{ $t("categories.singular") }} - </option>
      </select>
    </span>
  </span>
</template>

<script>

export default {
  computed: {
    project_areas: {
      get() {
        try {
          this.project_area_id = this.$store.state.project_areas[0].id
        } catch(err){
          // do nothing
        }
        return this.$store.state.project_areas.filter(area => {
          return area.file_cabinet === false
        })
      }
    }
  }, 
  data() {
    return {
      project_area_id: '',
      project_area_name: '',
      showNewProjectForm: false
    };
  },
  methods: {
    changeListener: function(event){
      this.$parent.project_area_id = this._data.project_area_id
      this.$parent.project_area_name = this._data.project_area_name

      if(event.target.value == 'new_project'){
        this.showNewProjectForm=true
      }
    },
    showExistingProjectAreas: function(){
      this.project_area_id = this.$store.state.project_areas[0].id
      this.showNewProjectForm=false
    },
    resetData: function(){
      this.project_area_id = ''
      this.project_area_name = ''
      this.showNewProjectForm = false
    }
  }  
}
</script>
